"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.empty = undefined;

var _EmptyObservable = require("./EmptyObservable");

var empty = exports.empty = _EmptyObservable.EmptyObservable.create;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/observable/empty.js
// module id = 436
// module chunks = 177